import React, { useState, Fragment } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import moment from "moment";
import OpenInNewIcon from "mdi-react/OpenInNewIcon";
import {
  _capitalizeText,
  _shouldShow,
  _getBuildingPhotos,
  _formatPrice,
  _formatNumber,
  _getBuildingURL,
  _checkBuildingAltAdr,
  _showAltAdrs,
  _getCrossStreet,
  _getOccupancy,
  _getProjectType,
  _formatNum,
  _getServiceLevel,
} from "../../../../../shared/helpers/utils";
import TaxAbatement from "../../../../../shared/components/TaxAbatement";
import { Grid } from "@material-ui/core";
import FeatureIcon from "mdi-react/CheckCircleOutlineIcon";
import NoFeatureIcon from "mdi-react/CheckboxBlankCircleOutlineIcon";
import LinkIcon from "mdi-react/InformationOutlineIcon";
import MapIcon from "mdi-react/MapMarkerCircleIcon";
import { Link } from "react-router-dom";

const MainInfoUnits = (props) => {
  const { buildingRes, hood, boro } = props;
  let first_close_year = buildingRes.first_closing_date
    ? parseInt(moment(buildingRes.first_closing_date).format("YYYY"))
    : 0;

  if (first_close_year <= 1970) {
    first_close_year = 9999;
  }

  if (
    !buildingRes.pipeline_total_units_proposed &&
    buildingRes.pipeline_dwelling_units_proposed
  ) {
    buildingRes.pipeline_total_units_proposed =
      buildingRes.pipeline_dwelling_units_proposed;
  }
  let bblDisplay = false;
  
  let buildingOwnershipType =
    buildingRes.ownership_type && _shouldShow(buildingRes.ownership_type)
      ? buildingRes.ownership_type.toString().toLowerCase().trim()
      : false;
  
  let fullBbl = false;
  if (buildingRes.block && buildingRes.block > 0 && buildingRes.lot > 0) {
    let borough_code = buildingRes.borough_code;
    let block = buildingRes.block;
    let lot = buildingRes.lot;
    fullBbl = `${borough_code}${String(block).padStart(5, '0')}${String(lot).padStart(4, '0')}`;
    if (buildingOwnershipType && !buildingOwnershipType.includes("condo")) {
      bblDisplay = (
        <Fragment>
          <div>
            {block} | {lot}{" "}
            <Link
              to={{
                pathname: `https://a836-acris.nyc.gov/bblsearch/bblsearch.asp?borough=${borough_code}&block=${block}&lot=${lot}`,
              }}
              target="_blank"
              replace
              className="fa fa-external-link"
            >
              ACRIS <i aria-hidden="true" />
            </Link>
          </div>
        </Fragment>
      );
    } else {
      bblDisplay = (
        <Fragment>
          {block} | {lot}
        </Fragment>
      );
    }
  }
  return (
    <Fragment>
      <div className="product-summary__info project-product-summary_info">
        <div>
          {buildingRes && buildingRes.display_full_street_address && (
            <p
              className={`${
                buildingRes && buildingRes.display_full_street_address
                  ? "has-info"
                  : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Primary Address:
              <span className="project_details-text_style">
                <Fragment>
                  {_capitalizeText(buildingRes.display_full_street_address)}
                </Fragment>
              </span>
            </p>
          )}

          {buildingRes && buildingRes.name && (
            <p
              className={`${
                buildingRes && buildingRes.name ? "has-info" : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Building Name:
              <span className="project_details-text_style">
                <Fragment>{_capitalizeText(buildingRes.name)}</Fragment>
              </span>
            </p>
          )}

          {buildingRes && _getCrossStreet(buildingRes) && (
            <p
              className={`${
                _getCrossStreet(buildingRes) ? "has-info" : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Cross Streets:
              <span className="project_details-text_style">
                <Fragment>{_getCrossStreet(buildingRes)}</Fragment>
              </span>
            </p>
          )}
          {hood && (
            <p className={`${hood ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Neighborhood:
              <span className="project_details-text_style">
                <Fragment>
                  {hood === "nyc" ? (
                    "NYC"
                  ) : (
                    <span className="u_link">{_capitalizeText(hood)}</span>
                  )}
                </Fragment>
              </span>
            </p>
          )}
          {boro && (
            <p className={`${boro ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Borough:
              <span className="project_details-text_style">
                <Fragment>
                  {boro === "new york" ? (
                    "New York"
                  ) : (
                    <span className="u_link">{_capitalizeText(boro)}</span>
                  )}
                </Fragment>
              </span>
            </p>
          )}
          {buildingRes && buildingRes.zip && (
            <p className={`${buildingRes.zip ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Zip Code:
              <span className="project_details-text_style">
                <Fragment>{buildingRes.zip}</Fragment>
              </span>
            </p>
          )}
          {bblDisplay && (
            <p
              className={`${bblDisplay ? "has-info d-flex" : "no-info d-flex"}`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Block & Lot:
              <span className="project_details-text_style">{bblDisplay}</span>
            </p>
          )}
          {fullBbl && (
            <p className="has-info">
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Parcel Map:
              <span className="project_details-text_style">
                <Link
                  to={{
                    pathname: `https://propertyinformationportal.nyc.gov/parcels/parcel/${fullBbl}`,
                  }}
                  target="_blank"
                  className="fa fa-external-link"
                >
                  View Parcel <i aria-hidden="true" />
                </Link>
              </span>
            </p>
          )}
          <p className={`${buildingOwnershipType ? "has-info" : "no-info"}`}>
            <FeatureIcon className="has-info" />
            <NoFeatureIcon className="no-info" />
            Building Type:
            <span className="project_details-text_style">
              {buildingOwnershipType ? (
                <Fragment>{_capitalizeText(buildingOwnershipType)}</Fragment>
              ) : (
                <span className="no-info">--</span>
              )}
            </span>
          </p>
          
          {buildingRes.year_built && _shouldShow(buildingRes.year_built) ? (
            <p className={`${buildingRes.year_built ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Year Built:
              <span className="project_details-text_style">
                {buildingRes.year_built ? buildingRes.year_built : "--"}
              </span>
            </p>
          ) : null}
          {buildingRes.year_converted && _shouldShow(buildingRes.year_converted) && buildingRes.year_converted > buildingRes.year_built  ? (
            <p className={`${buildingRes.year_converted ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Year Converted:
              <span className="project_details-text_style">
                {buildingRes.year_converted ? buildingRes.year_converted : "--"}
              </span>
            </p>
          ) : null}

         

          <TaxAbatement {...props} />
        </div>
      </div>
    </Fragment>
  );
};



const MainInfoAreaNew = (props) => {
  const { buildingRes } = props;
  let first_close_year = buildingRes.first_closing_date
    ? parseInt(moment(buildingRes.first_closing_date).format("YYYY"))
    : 0;

  if (first_close_year <= 1970) {
    first_close_year = 9999;
  }
  return (
    <Fragment>
      <div className="product-summary__info project-product-summary_info">
        <div>
          {buildingRes &&
            buildingRes.total_floors &&
            _shouldShow(buildingRes.total_floors) && (
              <p
                className={`${
                  buildingRes.total_floors ? "has-info" : "no-info"
                }`}
              >
                <FeatureIcon className="has-info" />
                <NoFeatureIcon className="no-info" />
                Floors:
                <span className="project_details-text_style">
                  {buildingRes.total_floors
                    ? _formatNum(buildingRes.total_floors) + " floors"
                    : "--"}
                </span>
              </p>
            )}
          {buildingRes.number_of_buildings > 1 &&
            <Fragment>
            <p
              className={`${
                buildingRes &&
                buildingRes.residential_units &&
                _shouldShow(buildingRes.residential_units)
                  ? "has-info"
                  : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Complex:
              <span className="project_details-text_style">
                {buildingRes &&
                buildingRes.number_of_buildings &&
                _shouldShow(buildingRes.number_of_buildings) ? (
                  <Fragment>
                    {_formatNum(buildingRes.number_of_buildings)} buildings
                  </Fragment>
                ) : (
                  <span className="no-info">--</span>
                )}
              </span>
            </p>
            <p
              className={`${
                buildingRes &&
                buildingRes.total_units &&
                _shouldShow(buildingRes.total_units)
                  ? "has-info"
                  : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
               Units in Complex:
              <span className="project_details-text_style">
                {buildingRes &&
                buildingRes.total_units &&
                _shouldShow(buildingRes.total_units) ? (
                  <Fragment>
                    {buildingRes.residential_units > buildingRes.total_units ?  _formatNum(buildingRes.residential_units) : _formatNum(buildingRes.total_units)} units
                  </Fragment>
                ) : (
                  <span className="no-info">--</span>
                )}
              </span>
            </p>
            </Fragment>
          }
          <p
            className={`${
              buildingRes &&
              buildingRes.inventory_total &&
              _shouldShow(buildingRes.inventory_total)
                ? "has-info"
                : "no-info"
            }`}
          >
            <FeatureIcon className="has-info" />
            <NoFeatureIcon className="no-info" />
             Units in Building:
            <span className="project_details-text_style">
              {buildingRes &&
              buildingRes.inventory_total &&
              _shouldShow(buildingRes.inventory_total) ? (
                <Fragment>
                  {_formatNum(buildingRes.inventory_total)} units
                </Fragment>
              ) : (
                <span className="no-info">--</span>
              )}
            </span>
          </p>
          {buildingRes.building_access &&
          _shouldShow(buildingRes.building_access) ? (
            <p
              className={`${
                buildingRes.building_access ? "has-info" : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Access:
              <span className="project_details-text_style">
                <Fragment>
                  {_capitalizeText(
                    buildingRes.building_access[0].replace(/_/g, " ")
                  )}
                </Fragment>
              </span>
            </p>
          ) : null}

          {buildingRes.building_service_level &&
          _shouldShow(buildingRes.building_service_level) ? (
            <p
              className={`${
                buildingRes.building_service_level ? "has-info" : "no-info"
              }`}
            >
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Service Level:
              <span className="project_details-text_style">
                <Fragment>
                  {_capitalizeText(
                    _getServiceLevel(buildingRes.building_service_level)
                  )}
                </Fragment>
              </span>
            </p>
          ) : null}

          {buildingRes.sq_ft && _shouldShow(buildingRes.sq_ft) ? (
            <p className={`${buildingRes.sq_ft ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Floor Area:
              <span className="project_details-text_style">
                <Fragment>
                  {buildingRes.sq_ft
                    ? _formatNum(buildingRes.sq_ft) + " sqft"
                    : "--"}
                </Fragment>
              </span>
            </p>
          ) : null}

          {buildingRes.lot_area ? (
            <p className={`${buildingRes.lot_area ? "has-info" : "no-info"}`}>
              <FeatureIcon className="has-info" />
              <NoFeatureIcon className="no-info" />
              Lot Size:
              <span className="project_details-text_style">
                <Fragment>
                  {buildingRes.lot_area
                    ? _formatNum(buildingRes.lot_area) + " sqft"
                    : "--"}
                </Fragment>
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </Fragment>
  );
};

const BuildingDetailsCard = (props) => {
  const { buildingRes } = props;

  let images = _getBuildingPhotos(buildingRes);

  if (images && images.length > 0) {
    images = images.map((image) => {
      return { src: image };
    });
  }
  const buildingAltAdr = _checkBuildingAltAdr(buildingRes);
  return (
  
      <Card>
        <CardBody className="no-border no-padding">
          <div className="profile-card d-block">
            <Grid className="profile-card__info" container>
              <Grid item xs={12} md={6} lg={6} sm={12}>
                <MainInfoUnits {...props} />
              </Grid>
              <Grid item xs={12} md={6} lg={6} sm={12}>
                <MainInfoAreaNew {...props} />
              </Grid>
              
              
              <Grid item xs={12} md={12} lg={12} sm={12} className={"mt-3"}>
                <Fragment>
                  <div className="product-summary__info project-product-summary_info">
                    <div>
                      {buildingRes && buildingAltAdr && (
                        <div className="quick-links">
                          <div className="link-section">
                            <p className="title">
                              <MapIcon
                                className={`${
                                  buildingRes && buildingAltAdr
                                    ? "has-info"
                                    : "no-info"
                                }`}
                              />
                              Alternate Addresses:
                            
                            {Array.isArray(buildingAltAdr) ? (
                              <Fragment>
                                {buildingAltAdr.map((addy) => {
                                  return <span className="project_details-text_style">{addy}</span>;
                                })}
                              </Fragment>
                            ) : typeof buildingAltAdr === "string" ? (
                              <span className="project_details-text_style">{buildingAltAdr}</span>
                            ) : null}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Fragment>
              </Grid>
            </Grid>
          </div>
        </CardBody>
      </Card>
    
  );
};

export default BuildingDetailsCard;
